import React from 'react';
import { startsWith } from 'lodash';
import { createRoot } from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import { Config } from '@forgerock/javascript-sdk';

import { AM_URL, REALM_PATH, JOURNEY_LOGIN, ENDUSER_CLIENT_ID } from '@/global';
import { BrowserAgent } from '@newrelic/browser-agent';
import { getSpecificEnv } from '@availity/env-var';

import App from './App';
import { ContextProvider } from './context';
import './index.scss';

const specificEnv = getSpecificEnv();

const getNewRelicApplicationId = (env) => {
  let output;

  if (env === 'prod') {
    output = '1835004645';
  } else if (env === 'qap') {
    output = '1835013338';
  } else if (startsWith(env, 'q')) {
    output = '1835004644';
  } else {
    output = '1835004640';
  }

  return output;
};

const newRelicApplicationID = getNewRelicApplicationId(specificEnv);
const nrLicKey = '39e3c32b0f';

// The rest of your client-side application imports

// Populate using values in copy-paste JavaScript snippet.
const options = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: nrLicKey,
    applicationID: newRelicApplicationID,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: '8926',
    trustKey: '8926',
    licenseKey: nrLicKey,
    agentID: newRelicApplicationID,
    applicationID: newRelicApplicationID,
  }, // NREUM.loader_config
};

// The agent loader code executes immediately on instantiation.
// eslint-disable-next-line no-new
new BrowserAgent(options);
// The rest of your client-side application code

Config.set({
  clientId: ENDUSER_CLIENT_ID,
  redirectUri: `${window.location.origin}/web/onboarding/availity-fr-ui/callback`,
  scope: 'openid profile email',
  serverConfig: {
    baseUrl: AM_URL,
    timeout: '30000',
  },
  realmPath: REALM_PATH,
  tree: JOURNEY_LOGIN,
});

const domNode = document.getElementById('root');
if (!domNode) throw new Error('Unable to find root node');
const root = createRoot(domNode);

root.render(
  <ContextProvider>
    <Router>
      <App />
    </Router>
  </ContextProvider>
);
